import { z } from "zod";
import { timestamp } from "./timestamp";
import { pickemsEntryData } from "./pickems";

const entryBase = z.object({
  status: z.string(),
  updatedAtTs: timestamp,
  scheduledStartTimeTs: timestamp,
  createdAtTs: timestamp,
  count: z.number(),
  updatedAt: z.string().datetime(),
  scheduledStartTime: z.string().optional(),
  referenceId: z.string().uuid(),
  entryType: z.enum(["BET", "PICKEM"]),
  createdAt: z.string().datetime(),
  entryId: z.number(),
  data: z.record(z.string(), z.any()),
});

const pickemsEntry = entryBase.extend({
  entryType: z.literal("PICKEM"),
  data: pickemsEntryData,
});

const betEntry = entryBase.extend({
  entryType: z.literal("BET"),
  data: z.object({
    stake: z.number(),
  }),
});

/**
 * This is the schema for the user entries collection in Firestore. The `data`
 * property is discriminated based on the `entryType` being `BET` or `PICKEM`.
 *
 * /users/{userId}/entries
 */
const userEntry = z.union([betEntry, pickemsEntry]);

type PickemsEntry = z.infer<typeof pickemsEntry>;

export { userEntry, betEntry, pickemsEntry };
export type { PickemsEntry };
